<template>
  <div>

    <form @submit.prevent="restorePayments">

      <div class="form-group">
        <label for="letter">Текст (опциональное поле)</label>
        <input v-model="text" id="letter" class="form-control">
      </div>

      <p class="mb-3">
        Укажите игроков и платежи в следующем формате.<br>
        <code>
          player_id,sku<br>
          player_id,sku<br>
          player_id,sku<br>
          ...
        </code>
      </p>

      <p class="mb-3">
        Для SKU не нужно вказывать префикс<br>
        <code>games.bit.storyngtonhall.</code>
      </p>

      <p class="mb-3">
        Префикс будет добавлен автоматически.
      </p>

      <p class="mb-3">
        Пример<br>
        <code>
          344661,fashion21_3<br>
          378327,coins_1<br>
          7021456,regular_pack_7<br>
          469180,coins_1<br>
          7122935,coins_1<br>
          344661,coins_1<br>
        </code>
      </p>

      <div class="form-group mb-3">
        <textarea
          v-model="dataStr"
          class="form-control"
          rows="5"
          required
        />
      </div>

      <delayed-action-button
        type="submit"
        variant="primary"
        :enabled="canInteract"
        :running="isRestoring"
        idleLabel="Restore"
        runningLabel="Restoring"
      />

    </form>

  </div>
</template>

<script>
import notifier from '../notifier.js';
import { HTTP } from '../http-common.js';
import { parseUint32 } from '../util.js';

import DelayedActionButton from './DelayedActionButton.vue';

export default {
  name: 'PlayersPaymentRestores',

  components: {
    DelayedActionButton,
  },

  data() {
    return {
      text: '',
      dataStr: '',
      isRestoring: false,
    };
  },

  computed: {
    canInteract() {
      return !this.isRestoring;
    },
  },

  methods: {
    restorePayments() {
      if(this.isRestoring) {
        return;
      }

      notifier.deleteSenderNotifications(this);

      const trimmedText = this.text.trim();

      const trimmedDataStr = this.dataStr.trim();
      if(trimmedDataStr.length === 0) {
        notifier.showError('Data must be specified.', {sender: this});
        return;
      }

      const paymentsRestoreDef = {
        text: trimmedText,
        payments: parsePayments(trimmedDataStr),
      };

      console.log(paymentsRestoreDef);

      this.isRestoring = true;

      HTTP.post('/restore_payments', paymentsRestoreDef)
      .then(response => {
        console.log(response);
        notifier.showSuccessAfterTransition('Payments restored.');
        this.$router.push({name: 'player_search'});
      })
      .catch(err => {
        this.isRestoring = false;
        notifier.showError(err, {sender: this});
      });
    },
  },
}

function parsePayments(str) {
  const lines = str.split('\n');

  const payments = [];

  for(const line of lines) {
    const trimmedLine = line.trim();
    if(trimmedLine.length === 0) {
      continue;
    }

    const payment = parsePayment(trimmedLine);
    payments.push(payment);
  }
  
  return payments;
}

// Payment string example: '344661,fashion21_3'.
function parsePayment(str) {
  const parts = str.split(',');
  if(parts.length !== 2) {
    throw new Error(`Invalid payment string: "${str}".`);
  }

  const playerIdStr = parts[0];
  const playerId = parseUint32(playerIdStr);
  if(playerId === null) {
    throw new Error(`Player is not uint32. Got "${playerIdStr}".`);
  }

  const SKU_PREFIX = 'games.bit.storyngtonhall.';
  const sku = SKU_PREFIX + parts[1];

  return {
    playerId: playerId,
    sku:      sku,
  };
}
</script>
